<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <DataSidebar
      @ok="addScanner"
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="addNewDataSidebar = false"
      :options="addObj"
    />

    <vs-table ref="table" :data="scanners">
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div
            class="p-3 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="addNewDataSidebar = true"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
      </div>

      <template slot="thead">
        <vs-th sort-key="title">Email</vs-th>
        <!-- <vs-th sort-key="category">Cost/Ticket</vs-th> -->
        <!-- <vs-th sort-key="popularity">Sales so far</vs-th> -->
        <!-- <vs-th sort-key="order_status">Order Status</vs-th> -->
        <!-- <vs-th sort-key="price">Price</vs-th> -->
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              {{ tr.email }}
            </vs-td>
            <!-- <vs-td>
                <p class="product-category">${{ tr.cost }}</p>
              </vs-td> -->
            <!-- <vs-td>
                ${{ tr.allTimeSales || 0 }}
              </vs-td> -->

            <vs-td>
              <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                <div
                  class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <feather-icon
                    icon="MoreHorizontalIcon"
                    svgClasses="h-4 w-4"
                  />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="del(tr)">
                    <span>Delete</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-td>

            <!-- <vs-td>
                <p class="product-price">${{ tr.price }}</p>
              </vs-td> -->
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import DataSidebar from "@/components/DataSidebar.vue";
import {
  arrToObj,
  notify,
  permissionFail,
  permissionFailNew,
  showPermissionError,
  $loading,
  validateEmail,
} from "@/assets/helper";
export default {
  components: {
    DataSidebar,
  },
  data() {
    return {
      scanners: [],
      addObj: {
        api: "/scanners",
        okText: "Add Scanner",
        label: "Scanner",
        fields: [
          {
            label: "Email",
            type: "email",
            field: "email",
            required: true,
          },
          {
            label: "Password",
            type: "text",
            field: "password",
            validate: "checkpass",
            required: true,
          },
        ],
      },
      isMounted: false,
      addNewDataSidebar: false,
    };
  },
  computed: {
    items() {
      return Object.values(this.products);
    },
    products() {
      return this.$store.state.products;
    },
    currentPage() {
      if (this.isMounted) {
        if (this.$refs.table) {
          return this.$refs.table.currentx;
        }
      }
      return 0;
    },
  },
  methods: {
    async getScanners() {
      $loading();
      let { data: scanners } = await this.$get("/scanners");
      this.scanners = scanners;
      $loading.close();
    },
    addScanner(sc) {
      let error = permissionFailNew(2) && permissionFailNew(1);
      if (error) {
        showPermissionError(error);
        this.addNewDataSidebar = false;
      }

      console.log("SCANNER", sc);

      this.$create(`/scanners`, {
        username: sc.email,
        email: sc.email,
        password: sc.password,
      }).then(({ data }) => {
        this.addNewDataSidebar = false;
        this.getScanners();
        notify({
          title: "Added",
          text: `Successfully Added Product!`,
          color: "success",
          iconPack: "feather",
          icon: "icon-alert-circle",
          position: "bottom-right",
        });
      });
    },
    edit(tr) {
      if (permissionFailNew(2) && permissionFailNew(1)) {
        return;
      }
      this.$router.push(`/product/${tr.id}`);
    },
    del(tr) {
      if (permissionFailNew(2) && permissionFailNew(1)) {
        return;
      }
      let self = this;
      function confirmed() {
        $loading;
        this.$delete(`/scanners/${tr.id}`)
          .then((x) => {
            notify({
              title: "Deleted",
              text: `Successfully Deleted!`,
              color: "success",
              iconPack: "feather",
              icon: "icon-alert-circle",
              position: "bottom-right",
            });
          })
          .catch(() => {
            notify({
              title: "Error",
              text: `There was an error deleting!`,
              color: "danger",
              iconPack: "feather",
              icon: "icon-alert-circle",
              position: "bottom-right",
            });
          })
          .finally(() => {
            self.getScanners();
            $loading.close();
          });
      }

      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: `Delete Scanner`,
        text: "You are about to Delete this scanner. This user will be permanently removed.",
        accept: confirmed,
      });

      console.log("del", tr);
    },
  },
  async created() {
    this.getScanners();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
